import { render, staticRenderFns } from "./TarifIndex.vue?vue&type=template&id=36ba7475&scoped=true&"
import script from "./TarifIndex.vue?vue&type=script&lang=js&"
export * from "./TarifIndex.vue?vue&type=script&lang=js&"
import style0 from "./TarifIndex.vue?vue&type=style&index=0&id=36ba7475&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ba7475",
  null
  
)

export default component.exports